/** @type {import('./global')} */
import { format } from "date-fns";
import React, { createContext, useState } from "react";

/**
 * @type {React.Context<BudgetType>}
 */
/**
 * @typedef Reporting_ContextType
 * @property {string[]} selectedRadiobutton
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedRadiobutton
 * @property {string[]} SelectedEmail
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedEmail
 * @property {string[]} SelectedTab
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedTab
 * @property {string[]} selectedDate
 * @property {React.Dispatch<React.SetStateAction<string[]>>} setSelectedDate
 * @property {string[]} exportType
 * @property {React.Dispatch<React.SetStateAction<string>>} setExportType
 * @property {string[]} selectedColumns
 * @property {React.Dispatch<React.SetStateAction<string>>} setSelectedColumns
 */

export const ReportingContext = createContext();

/**
 * @returns {Reporting_ContextType}
 */
export const useReportingContext = () => {
  const [selectedRadiobutton, setSelectedRadiobutton] = useState("csv");
  const [selectedTagValues, setSelectedTagValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [tempSelectTagValues, setTempSelectTagValues] = useState([]);
  const [selectGroupBy, setSelectGroupBy] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedTab, setSelectedTab] = useState("Reporting Center");

  /** @type {UseState<string[]>} */
  const [SelectedEmail, setSelectedEmail] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedPeriod, setSelectedPeriod] = useState("");

  /** @type {UseState<string[]>} */
  const [SelectedFrequency, setSelectedFrequency] = useState("");

  /** @type {UseState<string[]>} */
  const [selectedCreateGroupBy, setSelectedCreateGroupBy] = useState("");

  /** @type {UseState<string[]>} */
  const [SelectedPeriodFilter, setSelectedPeriodFilter] = useState([]);

  /** @type {UseState<string[]>} */
  const [SelectedFrequencyFilter, setSelectedFrequencyFilter] = useState([]);

  /** @type {UseState<string[]>} */
  const [selectedDate, setSelectedDate] = useState(null);

  const [titlePeriod, setTitlePeriod] = useState();

  /** @type {UseState<string[]>} */
  const [selectedColumns, setSelectedColumns] = useState([]);

  /** @type {UseState<string[]>} */
  const [exportType, setExportType] = useState("default");

  const [reportingTotalCount, setReportingTotalCount] = useState(0);

  const [downloadId, setDownloadId] = useState();
  /** @type {UseState<string[]>} */
  const [range, setRange] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection",
    },
  ]);

  let fromDate = range[0].startDate
    ? format(range[0].startDate, "yyyy-MM-dd")
    : "";
  let toDate = range[0].endDate ? format(range[0].endDate, "yyyy-MM-dd") : "";

  const [dimensioValuenRefetch, setDimensionValueRefetch] = useState(() => () => {});

  const [dimensionValueData, setDimensionValueData] = useState({})

  const [SelectReportID, setSelectReportID] = useState("");
  const [isLayoverOpen, setIsLayoverOpen] = useState(false);
  const [EditdataId, setEditdataId] = useState();
  const [refetchTable, setRefetchTable] = useState(() => () => {});
  const [confirmationmodal, setConfirmationmodal] = useState(false);
  const [DeleteData, setDeleteData] = useState();
  const [selectTagKeys, setSelectTagKeys] = useState([]);
  const [selectDimesnionKeys, setSelectDimensionKeys] = useState("");

  return {
    selectedRadiobutton,
    setSelectedRadiobutton,
    selectedTagValues,
    setSelectedTagValues,
    selectedValues,
    setSelectedValues,
    tempSelectTagValues,
    setTempSelectTagValues,
    selectGroupBy,
    setSelectGroupBy,
    SelectedEmail,
    setSelectedEmail,
    SelectedTab,
    setSelectedTab,
    SelectedPeriod,
    setSelectedPeriod,
    SelectedFrequency,
    setSelectedFrequency,
    selectedCreateGroupBy,
    setSelectedCreateGroupBy,
    SelectReportID,
    setSelectReportID,
    SelectedPeriodFilter,
    setSelectedPeriodFilter,
    SelectedFrequencyFilter,
    setSelectedFrequencyFilter,
    reportingTotalCount,
    setReportingTotalCount,
    downloadId,
    setDownloadId,
    range,
    setRange,
    toDate,
    fromDate,
    selectedDate,
    setSelectedDate,
    titlePeriod,
    setTitlePeriod,
    exportType,
    setExportType,
    selectedColumns,
    setSelectedColumns,
    dimensioValuenRefetch,
    setDimensionValueRefetch,
    selectDimesnionKeys,
    setSelectDimensionKeys,
    dimensionValueData,
    setDimensionValueData,

    EditdataId,
    setEditdataId,
    isLayoverOpen,
    setIsLayoverOpen,
    confirmationmodal,
    setConfirmationmodal,
    selectTagKeys,
    setSelectTagKeys,
    DeleteData,
    setDeleteData,
    refetchTable,
    setRefetchTable,
  };
};

export const ReportingProvider = ({ children }) => {
  const context = useReportingContext();

  return (
    <>
      <ReportingContext.Provider value={context}>
        {children}
      </ReportingContext.Provider>
    </>
  );
};
